export const POLYGON_PROPOSAL_TITLE = 'Should XSwap V3 be deployed to Polygon?'
